var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2536 7.90476H4.74659M11.2536 7.90476L11.6424 6.44762C11.716 6.17257 11.62 5.88152 11.3939 5.69333L10.8469 5.2381M11.2536 7.90476H10.0335V8.47619C10.0335 8.58133 10.1246 8.66667 10.2369 8.66667H11.0502C11.1625 8.66667 11.2536 8.58133 11.2536 8.47619V7.90476ZM4.74659 7.90476L4.3578 6.44762C4.28419 6.17257 4.38016 5.88152 4.60628 5.69333L5.15328 5.2381M4.74659 7.90476H5.96665V8.47619C5.96665 8.58133 5.87555 8.66667 5.76331 8.66667H4.94993C4.83769 8.66667 4.74659 8.58133 4.74659 8.47619V7.90476ZM5.15328 5.2381L5.55996 3.71429C5.55996 3.71429 6.78002 3.33333 8.00008 3.33333C9.22014 3.33333 10.4402 3.71429 10.4402 3.71429L10.8469 5.2381M5.15328 5.2381H10.8469M13.3334 5.42105C13.3334 9.10526 8.00008 15 8.00008 15C8.00008 15 2.66675 9.10526 2.66675 5.42105C2.66675 2.97989 5.05519 1 8.00008 1C10.945 1 13.3334 2.97989 13.3334 5.42105Z",
    stroke: "#959EB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerObject);
export default __webpack_public_path__ + "static/media/marker-object.1533842abe190064cd50187368d2f865.svg";
export { ForwardRef as ReactComponent };